export default __webpack_public_path__ + "static/media/gama-loco.7cf6ad06.webp";